<template>
  <div class="flex flex-col flex-wrap">
    <div class="pt-16 px-12">
        <ProfileHeader/>
    </div>
    <div class="py-16">
        <Navigation/>
    </div>
  </div>
</template>


<script>
import ProfileHeader from "../components/ProfileHeader"
import NewAlbumButton from "../components/NewAlbumButton"
import Navigation from "../components/Navigation"

export default {
    name: 'Menu',
    components: {
        ProfileHeader,
        NewAlbumButton,
        Navigation,
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Menu.vue